import { Theme } from '@material-ui/core';

export const styles = (theme: Theme) => ({
  grid: {
    background: 'rgba(66,147,33,.78)',
    padding: 2,
  },
  listSubheader: {
    backgroundColor: theme.palette.grey[200],
    lineHeight: '31px',
  },
});
